<template>
  <div class="bienvenida-page">
    <p class="versiculo-referencia-fija" ref="versiculoRef"> </p>

    <!-- Contenedor fecha -->
    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Viernes</p>
      <p class="fecha-dia-numero" ref="numeroRef">12</p>
      <p class="fecha-mes" ref="mesRef">JUNIO</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
           <p class="versiculo-texto">
          Hace&nbsp; <span class="letra-quince"> 15 años</span>&nbsp;  comenzó mi historia, un viaje lleno de risas, aprendizajes y sueños compartidos.
<br><br>

Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria. Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes tienen un lugar en mi corazón.
<br><br>

Esta invitación es una ventana a mi corazón, y me emociona que estés aquí para acompañarme.
Bienvenidos a un capítulo inolvidable de este cuento que apenas comienza.<br>
      </p>
        </div>
      </div>
    </div>

    <!-- Grupo decorativo 1 (Con Rama Larga) -->
    <div class="disco-group disco1-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama1Ref" />
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco1Ref" />
    </div>

    <!-- Grupo decorativo 2 (Con Rama Larga) -->
    <div class="disco-group disco2-group">
      <img src="@/assets/rama.png" alt="rama" class="rama-decorativa" ref="rama2Ref" />
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco2Ref" />
    </div>

    <!-- Grupo decorativo 3 -->
    <div class="disco-group disco3-group">
      <img src="@/assets/fl.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');
    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);
    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(el);
    };

    onMounted(() => {
      // Animaciones de texto originales
      animateOnScroll(granDiaRef.value, () => gsap.fromTo(granDiaRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8 }));
      animateOnScroll(diaSemanaRef.value, () => gsap.fromTo(diaSemanaRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 }));
      animateOnScroll(numeroRef.value, () => gsap.fromTo(numeroRef.value, { opacity: 0, y: -80, scale: 0.7 }, { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'bounce.out' }));
      animateOnScroll(mesRef.value, () => gsap.fromTo(mesRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.2 }));
      animateOnScroll(anioRef.value, () => gsap.fromTo(anioRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.3 }));
      animateOnScroll(mensajeRef.value, () => gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1 }));
      animateOnScroll(versiculoTextRef.value, () => gsap.fromTo(versiculoTextRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1 }));

      // Función para animar Flor + Rama naciendo
      const animarCombo = (discoEl, ramaEl, delay = 0) => {
        const tl = gsap.timeline({ delay });
        // La flor aparece rotando
        tl.fromTo(discoEl, { opacity: 0, rotate: -20, scale: 0.5 }, { opacity: 1, rotate: 0, scale: 1, duration: 1.2, ease: "power3.out" });
        // La rama "crece" desde atrás con efecto elástico
        if (ramaEl) {
          tl.fromTo(ramaEl, 
            { opacity: 0, scale: 0, transformOrigin: "center center" }, 
            { opacity: 1, scale: 1, duration: 1.5, ease: "elastic.out(1, 0.5)" }, 
            "-=0.7"
          );
        }
      };

      animateOnScroll(disco1Ref.value, () => animarCombo(disco1Ref.value, rama1Ref.value));
      animateOnScroll(disco2Ref.value, () => animarCombo(disco2Ref.value, rama2Ref.value, 0.2));
      animateOnScroll(disco3Ref.value, () => animarCombo(disco3Ref.value, null, 0.4));
    });

    return {
      mensaje, granDiaRef, diaSemanaRef, numeroRef, mesRef, anioRef,
      mensajeRef, versiculoTextRef, versiculoRef, disco1Ref, disco2Ref, disco3Ref,
      rama1Ref, rama2Ref
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  background: transparent;
  color: black;
  min-height: 100vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden; /* Para que las ramas largas no den problemas */
}

/* Fecha Estilo Dorado */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
  position: relative;
  z-index: 5;
}

.fecha-gran-dia, .fecha-dia-semana, .fecha-dia-numero, .fecha-mes, .fecha-anio {
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0px 1px 1px rgba(0,0,0,0.3));
  display: block;
  margin: 0 auto;
}

.fecha-gran-dia { font-family: 'CynthiaJuneJF', cursive; font-size: 62px; }
.fecha-dia-semana { font-family: 'fecha', serif; font-size: 29px; margin: 10px 0; }
.fecha-dia-numero { font-family: 'fecha', serif; font-size: 72px !important; font-weight: bold; }
.fecha-mes { font-family: 'Playfair Display', serif; font-size: 26px; font-weight: 600; letter-spacing: 2px; }
.fecha-anio { font-family: 'Poppins', sans-serif; font-size: 16px; font-style: italic; }

/* Contenido */
.bienvenida-container { display: flex; flex-direction: column; align-items: center; }
.mensaje-bienvenida { font: 300 19px 'Josefin Sans', sans-serif; color: #000; text-align: center; line-height: 2; }
.versiculo-container { margin: -20px 20px 0; text-align: center; }
.versiculo-texto { font: 18px 'quote', sans-serif; line-height: 1.8; color: #333; }
.letra-quince {
  font-family: 'CynthiaJuneJF', cursive; font-size: 54px;
  background: linear-gradient(110deg, #8a6d3b 0%, #bf953f 20%, #6e6b3b 50%, #bf953f 80%, #8a6d3b 100%);
  -webkit-background-clip: text; background-clip: text; color: transparent;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.3));
}

/* Decoraciones */
.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.disco {
  width: 140px;
  height: auto;
  position: relative;
  z-index: 2; /* Flor al frente */
}

.rama-decorativa {
  position: absolute;
  width: 270px; /* Rama más larga que la flor */
  height: auto;
  margin-top:60px;
  z-index: 1; /* Rama atrás */
  opacity: 0;
  filter: brightness(1.1); /* Toque de luz */
}

/* Posiciones */
.disco1-group { top: -2%; right: -15%; width: 150px !important;  }
.disco2-group { top: 20%; left: -12%; width: 120px; }
.disco3-group { bottom: -6%; left: -10%; z-index:99; opacity: 0 !important; }
</style>